import React from 'react'

import { Page } from '../../../../components/layouts/page'
import { Column } from '../../../../components/layouts/columns'
import { FormPosition } from './form/formPosition'
import useAddPosition from './hooks/useAddPosition'

export const AdminAddPositions = () => {
  const { loading, newItem, dataContext, setNewItem, handleAddItem } = useAddPosition()

  return (
    <Page.Section className="is-fullheight-with-navbar">
      {/* <Form.Root action={() => {criarItem();}}> */}
      <Column.Root>
        <Column.Content>
          <p className="subtitle is-size-3">Adicionar Cargo</p>
        </Column.Content>
      </Column.Root>
      <FormPosition
        loading={loading}
        values={newItem}
        setValues={setNewItem}
        options={dataContext}
        action={handleAddItem}
        disabledList={{}}
      />
      {/* </Form.Root > */}
    </Page.Section>
  )
}
